import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useLocalStorage } from "./useLocalStorage";

export interface User {
  id: string;
  name: string;
  phoneNumber: string;
  authToken?: string;
  birthDate: string;
  birthPlace: string;
  birthTime: string;
  gender: string;
  profileImage: string;
  firstTime: boolean;
  userBalance: number;
}

export const useUser = () => {
  const { user, setUser } = useContext(AuthContext);
  const { setItem } = useLocalStorage();

  const addUser = (user: User, callback: () => void) => {
    setUser(user);
    setItem("user", JSON.stringify(user), callback);
  };

  const removeUser = () => {
    setUser(null);
    setItem("user", "",()=>{});
  };

  return { user, addUser, removeUser, setUser };
};
